const ConsentCategory = {
    StrictlyNecessary: "C0001",
    Performance: "C0002",
    Functional: "C0003",
    Targeting: "C0004",
    SocialMedia: "C0005",
};
function hasGrantedSpecifiedPermission(category) {
    return (window["OnetrustActiveGroups"] || "").split(",").includes(category);
}
export const OneTrust = {
    isPresent: () => {
        return "OneTrust" in window;
    },
    hasGrantedPermission: () => {
        return hasGrantedSpecifiedPermission(ConsentCategory.Targeting);
    },
    onConsentChanged: (callback) => {
        if (!window.OneTrust) {
            return;
        }
        window.OneTrust.OnConsentChanged(callback);
    },
};
